export default __webpack_public_path__ + "static/media/flip_card_5.82088ae9.png";